/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";

//i18n
import { withTranslation } from "react-i18next";

// Moment

// Datepicker
import "react-datepicker/dist/react-datepicker.css";
// import pt from "date-fns/locale/pt";

const CustomColorPicker = ({ t, className, onChange, defaultValue, tReady, ...inputProps}) => {
  const wrapperRef = useRef("");
  const [colorValue, setColorValue] = useState("");
  const [menuColorIsOpen, setMenuColorIsOpen] = useState(false);

  useEffect(() => {
    setColorValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    /**
     * CloseMenu if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setMenuColorIsOpen(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <React.Fragment>
      <div className="input-group colorpicker-default customColorComponent">
        <input
          className={className}
          type="text"
          placeholder={t("Select a color")}
          defaultValue={defaultValue}
          maxLength="6"
          onClick={() => setMenuColorIsOpen(!menuColorIsOpen)}
          readOnly
          {...inputProps}
        />
        <span className="input-group-append">
          <span className="input-group-text colorpicker-input-addon">
            <i
              style={{
                background: "#" + colorValue,
              }}
            ></i>
          </span>
        </span>
      </div>
      {menuColorIsOpen ? (
        <div ref={wrapperRef}>
          <SketchPicker
            color={"#" + colorValue}
            value={"#" + colorValue}
            width="250px"
            onChangeComplete={(color) => {
              const value = color.hex.substr(1, 6);
              setColorValue(value);
              onChange(value);
            }}
          />{" "}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default withTranslation()(CustomColorPicker);
